/**
 * Smooth-scroll to an in-page section AND strip the "#fragment" from the URL
 * so visitors never see e.g. "zozoventure.com/#services" in the address bar.
 *
 * Usage:
 *   <a href="#services" onClick={smoothScrollHash}>Services</a>
 *
 * Also works when the href is "/#services" (hash on home from another page).
 * In that case we only intercept if we're already on home — otherwise we let
 * React Router handle the navigation.
 */
export function smoothScrollHash(e) {
  const el = e.currentTarget;
  const href = el.getAttribute("href") || "";
  const hashIndex = href.indexOf("#");
  if (hashIndex === -1) return;

  const pathPart = href.slice(0, hashIndex); // "" or "/"
  const id = href.slice(hashIndex + 1); // "services"

  // If href is "/#services" and we're NOT on home, let router navigate first.
  if (pathPart && pathPart !== window.location.pathname) return;

  const target =
    id === "top" ? document.documentElement : document.getElementById(id);
  if (!target) return;

  e.preventDefault();
  target.scrollIntoView({ behavior: "smooth", block: "start" });

  // Strip the fragment from the URL without reloading or scrolling again
  const cleanUrl =
    window.location.pathname + window.location.search;
  window.history.replaceState(null, "", cleanUrl);
}
